import { applyMiddleware, legacy_createStore as createReduxStore, combineReducers, compose } from "redux";
import thunk from "redux-thunk";
import { rexReducer } from "@icg360/rex";
export var analysisReducer = function analysisReducer(state, action) {
  if (state === void 0) {
    state = {
      isLoading: false
    };
  }

  switch (action.type) {
    case "IS_LOADING":
      return {
        isLoading: true
      };

    case "LOAD_SUCCESS":
      return {
        isLoading: false
      };

    default:
      return state;
  }
};
var reducer = combineReducers({
  rex: rexReducer,
  analysisValidation: analysisReducer
}); // Redux dev tools

var composeEnhancers = compose;

if ( // If redux dev tools exist
window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ && // And this is not a production application environment
window.location.hostname !== "agents.sagesure.com" && window.location.hostname !== "policycentral.icg360.com" && window.location.hostname !== "fednat-agents.icg360.com") {
  composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
}

export var createStore = function createStore() {
  return createReduxStore(reducer, composeEnhancers(applyMiddleware(thunk)));
};
var store = createStore();
export default store;